import {
	endpointsMap,
	ICreateAppointmentOptions,
	ICreateAppointmentResponse
} from './ICustomShopperAppointments';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperAppointments
 */
class CustomShopperAppointments extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Create an Appointment
	 * @param {ICreateAppointmentOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {ICreateAppointmentResponse} - Array of customer groups
	 */
	public async createAppointment(fetchOptions: ICreateAppointmentOptions, throwOnError?: boolean): Promise<ICreateAppointmentResponse> {
		const response = await this.callCustomEndpoint<ICreateAppointmentResponse>(fetchOptions, endpointsMap.CREATE_APPOINTMENT);

		if (throwOnError && !response.confirmMessage) {
			throw new Error('Appointment cration failed');
		}

		return response;
	}
}

export default CustomShopperAppointments;
